import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  lista_precios: [],
  lista_precio_seleccionada: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};